import { useOutletContext } from "react-router-dom";

import SuperAdminDistributionChannelSettingsView from "../../views/SuperAdminDistributionChannelView/SuperAdminDistributionChannelSettingsView";

export default function SuperAdminDistributionChannelSettings() {
	const context = useOutletContext();

	return <SuperAdminDistributionChannelSettingsView {...context} />;
}
